jQuery(function($){ 
  
  
	// Fixed menu when scrolling down page
	$(window).on("scroll touchmove", function() {var $fromTop = $(window).scrollTop();$("body").toggleClass("fixed-menu", ($fromTop > 100));});
  
//   	var yourText = "<div>";
//   	$( ".font-size__basic h5" ).after(yourText);
//   	$( ".font-size__basic h5" ).before( "<div>");
 
  
});
